export default __webpack_public_path__ + "static/media/hero-tools-2.45149163.jpg";